<script setup lang="ts">
const d = new Date();
const currentYear = d.getFullYear();
</script>

<template>
  <span class="font-heading">&copy; {{ currentYear }} econnect international b.v</span>
</template>
